import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { approveCollaborationRequest, resetApproveCollaborationRequest } from "./approve-collaboration-request";

const initialState: ProcessingState = {
  processing: "idle",
};

export const approveCollaborationRequestReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(approveCollaborationRequest.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(approveCollaborationRequest.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(approveCollaborationRequest.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetApproveCollaborationRequest, () => {
    return initialState;
  });
});
